import { isEmpty } from "./isEmpty";
import { isNil } from "./isNil";

export const last = <T>(array: T[]): T | undefined => {
  if (isNil(array) || isEmpty(array)) {
    return undefined;
  }
  
  return array[array.length - 1];
};